module.exports = __webpack_public_path__ + "static/media/chemex.d5246391.svg";